import { Input } from '@arco-design/web-react';
import React from 'react';

export const InputID = () => {
  return <Input placeholder="请输入编号" allowClear />;
};
